import {
  Alert,
  AlertIcon,
  AlertTitle,
  Button,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Text,
  useToast,
} from "@chakra-ui/react";
import { Form, Formik } from "formik";
import { get } from "lodash";
import React, { useEffect, useMemo } from "react";
import { PRO_USER_REQUEST } from "./../../store/user/userActionType";
import { useDispatch } from "react-redux";
// import { useUsers } from "../../store/user/reducer";
import { useAccounts } from "../../store/account/reducer";
import * as Yup from "yup";
import { IAccount } from "../../types/account";
import { CalenderFormField } from "../FormFields/CalenderFormField/CalenderFormField";

interface Props {
  account: IAccount;
  isOpen: any;
  onClose: any;
}

const addSchema = Yup.object({
  subscriptionTill: Yup.number()
    .optional()
    .nullable(true)
    // checking self-equality works for NaN, transforming it to null
    .transform((_, val) => (val === Number(val) ? val : null)),
});

const UserProConfirmation: React.FC<Props> = ({ isOpen, onClose, account }) => {
  const dispatch = useDispatch();
  const { busy, message, accounts } = useAccounts();
  const toast = useToast();
  useEffect(() => {
    if (
      !busy &&
      !message &&
      !(accounts || []).find(
        (acc: Record<string, any>) => acc._id === account._id
      )
    ) {
      onClose();
    }
  }, [account._id, accounts, busy, message, onClose]);
  const initialValue = useMemo(() => {
    return {
      subscriptionTill: get(account, "user.subscriptionTill"),
    };
  }, [account]);

  const onSubmit = (values: Record<string, any>) => {
    const data = {
      userId: get(account, "user._id"),
      payload: {
        subscriptionTill: get(account, "user.isPro")
          ? null
          : values.subscriptionTill
          ? new Date(values.subscriptionTill)
          : null,
        isAdminPro: !get(account, "user.isPro"),
      },
    };
    dispatch({
      type: PRO_USER_REQUEST,
      data,
      onSuccess: () => {
        toast({
          title: !get(account, "user.isPro")
            ? `From now ${get(account, "user.email")} can use pro features`
            : `From now ${get(account, "user.email")} can not use pro features`,
          status: !get(account, "user.isPro") ? "success" : "warning",
          duration: 9000,
          position: "top",
          isClosable: true,
        });
        onClose();
      },
    });
  };

  return (
    <Formik
      initialValues={initialValue}
      validationSchema={addSchema}
      onSubmit={onSubmit}
    >
      {({ values, errors, touched, submitForm }) => (
        <Form>
          <Modal
            isOpen={isOpen}
            onClose={onClose}
            closeOnOverlayClick={false}
            size={"sm"}
          >
            <ModalOverlay />
            <ModalContent>
              <ModalHeader>User Pro</ModalHeader>
              <ModalCloseButton disabled={busy} />
              <ModalBody>
                {!get(account, "user.isPro") ? (
                  <>
                    <Text color="red">
                      {get(account, "user.isPro")
                        ? "Are sure to remove pro User ? "
                        : "Are sure to make pro User ? "}
                    </Text>
                    <Text> {get(account, "user.email")}</Text>
                    {message && (
                      <Alert status="error" zIndex={100}>
                        <AlertIcon />
                        <AlertTitle mr={2}>{message}</AlertTitle>
                      </Alert>
                    )}

                    <CalenderFormField
                      value={values["subscriptionTill"]}
                      required={true}
                      name={"Subscription Till : "}
                      fieldName={"subscriptionTill"}
                      placeholder={"Select a Date"}
                      error={
                        touched.subscriptionTill
                          ? (errors.subscriptionTill as string)
                          : undefined
                      }
                    />
                  </>
                ) : (
                  <>
                    <Text color="red">
                      {get(account, "user.isPro")
                        ? "Are sure to remove pro User ? "
                        : "Are sure to make pro User ? "}
                    </Text>
                    <Text> {get(account, "user.email")}</Text>
                  </>
                )}
              </ModalBody>
              <ModalFooter>
                <Button
                  variant="outline"
                  mr={3}
                  onClick={onClose}
                  disabled={busy}
                >
                  Close
                </Button>
                <Button
                  colorScheme="red"
                  variant={"outline"}
                  mr={3}
                  onClick={submitForm}
                  disabled={busy}
                >
                  Submit
                </Button>
              </ModalFooter>
            </ModalContent>
          </Modal>
        </Form>
      )}
    </Formik>
  );
};
export default UserProConfirmation;
